// @ts-ignore - vanilla js for workers
import Worker from 'worker-loader!./preloadImagesWorker.js';

const worker = new Worker();

export default function PreloadImage(url: string) {
    worker.postMessage({
        type: 'url',
        url,
    });
}

